// extracted by mini-css-extract-plugin
export default {"separator":"select_separator_separator__h8mjQ"};